<script setup lang="ts">
const appConfig = useAppConfig();
const colorMode = useColorMode();

onMounted(() => {
  // Force to light mode
  colorMode.preference = "light";
  colorMode.forced = true;
});
</script>

<template>
  <UApp
    :toaster="appConfig.toaster"
    :tooltip="appConfig.tooltip"
  >
    <NuxtLoadingIndicator color="#d38e1f" :height="3" />
    <NoScript>
      Mohon aktifkan JavaScript untuk menggunakan situs ini.
    </NoScript>

    <NuxtPage />
  </UApp>
</template>
